const prefix = 'daily_';

export const checkInOutRulesets = {
  name: prefix + 'check_in_out_rulesets',
  model_name: prefix + 'check_in_out_ruleset'
};
export const cancellationPolicies = {
  name: prefix + 'cancellation_policies',
  model_name: prefix + 'rental_cancellation_policy'
};
export const rentalRulesets = {
  name: prefix + 'rental_rulesets',
  model_name: prefix + 'rental_ruleset'
};
export const seasonalPrices = {
  name: prefix + 'seasonal_prices',
  model_name: prefix + 'seasonal_price'
};
export const seasonalConditions = {
  name: prefix + 'seasonal_conditions',
  model_name: prefix + 'seasonal_condition'
};
export const customers = {
  name: 'customers',
  model_name: 'customer',
};
export const bookingFiles = {
  name: 'booking_files',
  model_name: 'booking_file',
};
export const inquiries = {
  name: 'inquiries',
  model_name: 'inquiry',
};
export const reservations = {
  name: 'reservations',
  model_name: 'reservation',
};
export const payments = {
  name: 'payments',
  model_name: 'payment',
};



// WEBPACK FOOTER //
// ./src/backend/daily-rental/seeds/collections.js